import { render, staticRenderFns } from "./TextSubmission.vue?vue&type=template&id=0489117a&scoped=true&"
import script from "./TextSubmission.vue?vue&type=script&lang=js&"
export * from "./TextSubmission.vue?vue&type=script&lang=js&"
import style0 from "./TextSubmission.vue?vue&type=style&index=0&id=0489117a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489117a",
  null
  
)

export default component.exports